import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import SessionLayout from '../../layouts/SessionLayout'
import Session3 from './Session3'

export default class SessionIntro extends Component {
  render() {
    const { match } = this.props
    const { patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <SessionLayout title="prose.welcomeBack">
            <Session3 />
          </SessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SessionIntro/index.js